<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">

        <ul ngbNav #innerNav="ngbNav" [(activeId)]="innerCurrentSection" class="nav nav-tabs nav-bordered"
          role="tablist">
          <li [ngbNavItem]="1">
            <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 1" i18n>Info general</a>
            <ng-template ngbNavContent>
              <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded">

                <!-- General -->
                <div class="section-header">
                  <h5 class="section-title" i18n>GENERAL</h5>
                </div>
                <div class="row">
                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-3 d-flex align-items-center">
                      <label for="inputImpuestoAplicable" class="form-label" i18n>Impuestos General (%) (*)</label>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control text-end" id="inputImpuestoAplicable"
                        [(ngModel)]="model.impuesto_aplicable_general" name="impuesto_aplicable_general" required
                        maxlength="40" [disabled]="isCaseClosed() || disableOptions"
                        [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['impuesto_aplicable_general']?.invalid) || (f.form.controls['impuesto_aplicable_general']?.dirty || f.form.controls['impuesto_aplicable_general']?.touched) && f.form.controls['impuesto_aplicable_general']?.invalid }">
                      <div
                        *ngIf="(f.submitted && f.form.controls['impuesto_aplicable_general']?.invalid) || (f.form.controls['impuesto_aplicable_general']?.dirty || f.form.controls['impuesto_aplicable_general']?.touched) && f.form.controls['impuesto_aplicable_general']?.invalid">
                        <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-3 d-flex align-items-center">
                      <label for="selectCalculadora" class="form-label" i18n>Calculadora</label>
                    </div>
                    <div class="col-md-3">
                      <select class="form-select" id="selectCalculadora" [(ngModel)]="model.calculadora"
                        name="calculadora" required [disabled]="isCaseClosed() || disableOptions"
                        [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['calculadora']?.invalid) || (f.form.controls['calculadora']?.dirty || f.form.controls['calculadora']?.touched) && f.form.controls['calculadora']?.invalid }">
                        <option value="" disabled i18n>Seleccione</option>
                        <option value="CIAM_ABREVIADO" i18n>CIAM_ABREVIADO</option>
                        <option value="CIAM_ORDINARIO_2020" i18n>CIAM_ORDINARIO_2020</option>
                        <option value="CEA" i18n>CEA</option>
                        <option value="CIMA" i18n>CIMA</option>
                        <option value="CAM_2021" i18n>CAM_2021</option>
                        <option value="CAM_2022" i18n>CAM_2022</option>
                        <option value="CAM_2023" i18n>CAM_2023</option>
                        <option value="ARBITRO_EMERGENCIA" i18n>ARBITRO_EMERGENCIA</option>
                        <option value="ICAM" i18n>ICAM</option>
                      </select>
                      <div
                        *ngIf="(f.submitted && f.form.controls['calculadora']?.invalid) || (f.form.controls['calculadora']?.dirty || f.form.controls['calculadora']?.touched) && f.form.controls['calculadora']?.invalid">
                        <p class="validator-message" i18n>Campo obligatorio</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- DEMANDA y RECONVENCIÓN -->
                <div class="row">
                  <!-- Primera columna (6 columnas de ancho) -->
                  <div class="col-md-6">
                    <h5 class="section-title" i18n>DEMANDA</h5> <!-- Título de la primera columna -->

                    <!-- Cuantía Demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputCuantiaDemanda" class="form-label" i18n>Cuantía (*)</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputCuantiaDemanda"
                          [(ngModel)]="model.cuantia_demanda" name="cuantia_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions" (focus)="onFocus('cuantia_demanda')"
                          (blur)="onBlur('cuantia_demanda')"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['cuantia_demanda']?.invalid) || (f.form.controls['cuantia_demanda']?.dirty || f.form.controls['cuantia_demanda']?.touched) && f.form.controls['cuantia_demanda']?.invalid }">
                      </div>
                    </div>

                    <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                    <!-- % Pago demandantes demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoDemandantesDemanda" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else demandaDemandantesDefault">
                            <span i18n>Porcentaje de pago de los demandantes (%)</span>
                          </ng-container>
                          <ng-template #demandaDemandantesDefault>
                            <span i18n>Porcentaje de pago de los demandantes (%)</span>
                          </ng-template>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end" id="inputPorcentajePagoDemandantesDemanda"
                          [(ngModel)]="model.porcentaje_pago_demandantes_demanda"
                          name="porcentaje_pago_demandantes_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_demandantes_demanda']?.invalid) || (f.form.controls['porcentaje_pago_demandantes_demanda']?.dirty || f.form.controls['porcentaje_pago_demandantes_demanda']?.touched) && f.form.controls['porcentaje_pago_demandantes_demanda']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_demandantes_demanda']?.invalid) || (f.form.controls['porcentaje_pago_demandantes_demanda']?.dirty || f.form.controls['porcentaje_pago_demandantes_demanda']?.touched) && f.form.controls['porcentaje_pago_demandantes_demanda']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- % Pago demandados demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoDemandadosDemanda" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else demandaDemandadosDefault">
                            <span i18n>Porcentaje de pago de los demandados (%)</span>
                          </ng-container>
                          <ng-template #demandaDemandadosDefault>
                            <span i18n>Porcentaje de pago de los demandados (%)</span>
                          </ng-template>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end" id="inputPorcentajePagoDemandadosDemanda"
                          [(ngModel)]="model.porcentaje_pago_demandados_demanda"
                          name="porcentaje_pago_demandados_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_demandados_demanda']?.invalid) || (f.form.controls['porcentaje_pago_demandados_demanda']?.dirty || f.form.controls['porcentaje_pago_demandados_demanda']?.touched) && f.form.controls['porcentaje_pago_demandados_demanda']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_demandados_demanda']?.invalid) || (f.form.controls['porcentaje_pago_demandados_demanda']?.dirty || f.form.controls['porcentaje_pago_demandados_demanda']?.touched) && f.form.controls['porcentaje_pago_demandados_demanda']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                    <!-- Porcentaje Derecho Administración Demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputPorcentajeDerechoAdmDemanda" class="form-label" i18n>Derechos de Administración
                          (%) (*)</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputPorcentajeDerechoAdmDemanda"
                          [(ngModel)]="model.porcentaje_derecho_administracion_demanda"
                          name="porcentaje_derecho_administracion_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_derecho_administracion_demanda']?.invalid) || (f.form.controls['porcentaje_derecho_administracion_demanda']?.dirty || f.form.controls['porcentaje_derecho_administracion_demanda']?.touched) && f.form.controls['porcentaje_derecho_administracion_demanda']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_derecho_administracion_demanda']?.invalid) || (f.form.controls['porcentaje_derecho_administracion_demanda']?.dirty || f.form.controls['porcentaje_derecho_administracion_demanda']?.touched) && f.form.controls['porcentaje_derecho_administracion_demanda']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- Porcentaje Honorarios Árbitro Demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputPorcentajeHonorarioDemanda" class="form-label" i18n>Honorarios Árbitro (%)
                          (*)</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputPorcentajeHonorarioDemanda"
                          [(ngModel)]="model.porcentaje_honorario_arbitro_demanda"
                          name="porcentaje_honorario_arbitro_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_honorario_arbitro_demanda']?.invalid) || (f.form.controls['porcentaje_honorario_arbitro_demanda']?.dirty || f.form.controls['porcentaje_honorario_arbitro_demanda']?.touched) && f.form.controls['porcentaje_honorario_arbitro_demanda']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_honorario_arbitro_demanda']?.invalid) || (f.form.controls['porcentaje_honorario_arbitro_demanda']?.dirty || f.form.controls['porcentaje_honorario_arbitro_demanda']?.touched) && f.form.controls['porcentaje_honorario_arbitro_demanda']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                    <!-- Imputación conjunta derechos de admisión demanda -->
                    <div class="row mb-1 align-items-center">
                      <div class="col-md-12 d-flex justify-content-between align-items-center">
                        <label for="demanda_imputacion_conjunta_derechos_admision" class="form-label mb-0"
                          i18n>Imputación conjunta derechos de admisión</label>
                        <div class="form-check form-switch">
                          <input type="checkbox" class="form-check-input"
                            id="demanda_imputacion_conjunta_derechos_admision"
                            [(ngModel)]="model.demanda_imputacion_conjunta_derechos_admision"
                            name="demanda_imputacion_conjunta_derechos_admision"
                            [disabled]="isCaseClosed() || disableOptions">
                        </div>
                      </div>
                    </div>

                    <!-- Derechos de Admisión Demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputAdmisionDemanda" class="form-label" i18n>Derechos de admisión</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputAdmisionDemanda"
                          [(ngModel)]="model.demanda_provision_admision" name="demanda_provision_admision"
                          maxlength="40" [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('demanda_provision_admision')" (blur)="onBlur('demanda_provision_admision')">
                      </div>
                    </div>

                    <!-- Gastos Árbitros Demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputGastoArbitroDemanda" class="form-label" i18n>Gastos de los árbitros</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputGastoArbitroDemanda"
                          [(ngModel)]="model.demanda_provision_gasto_arbitro" name="demanda_provision_gasto_arbitro"
                          maxlength="40" [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('demanda_provision_gasto_arbitro')"
                          (blur)="onBlur('demanda_provision_gasto_arbitro')">
                      </div>
                    </div>

                    <!-- Gastos Expediente Demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputGastoExpedienteDemanda" class="form-label" i18n>Gastos del expediente</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputGastoExpedienteDemanda"
                          [(ngModel)]="model.demanda_provision_gasto_expediente"
                          name="demanda_provision_gasto_expediente" maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('demanda_provision_gasto_expediente')"
                          (blur)="onBlur('demanda_provision_gasto_expediente')">
                      </div>
                    </div>

                    <!-- Alquiler de Sala Demanda -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputAlquilerSalaDemanda" class="form-label" i18n>Alquiler de salas</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputAlquilerSalaDemanda"
                          [(ngModel)]="model.demanda_provision_alquiler_sala" name="demanda_provision_alquiler_sala"
                          maxlength="40" [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('demanda_provision_alquiler_sala')"
                          (blur)="onBlur('demanda_provision_alquiler_sala')">
                      </div>
                    </div>

                    <!-- Espacio subtítulo -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-12 d-flex align-items-center"><span i18n class="reparto-honorarios">Reparto de
                          honorarios del tribunal</span></div>
                    </div>

                    <!-- % Presidente -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoTribunalPresidenteDemanda" class="form-label" i18n>% Presidente
                          {{ getArbitroRolNombre('PRESIDENTE') }}</label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end"
                          id="inputPorcentajePagoTribunalPresidenteDemanda"
                          [(ngModel)]="model.porcentaje_pago_tribunal_presidente_demanda"
                          name="porcentaje_pago_tribunal_presidente_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.dirty || f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.touched) && f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.dirty || f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.touched) && f.form.controls['porcentaje_pago_tribunal_presidente_demanda']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- % Co-árbitro 1  -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoTribunalCoarbitro1Demanda" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else coarbitro1DemandaDefault">
                            <span i18n>% Co-árbitro demandante</span>
                          </ng-container>
                          <ng-template #coarbitro1DemandaDefault>
                            <span i18n>% Co-árbitro demandante</span>
                          </ng-template>
                          {{ getArbitroRolNombre('COARBITRO_1') }}
                        </label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end"
                          id="inputPorcentajePagoTribunalCoarbitro1Demanda"
                          [(ngModel)]="model.porcentaje_pago_tribunal_coarbitro_1_demanda"
                          name="porcentaje_pago_tribunal_coarbitro_1_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_demanda']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- % Co-árbitro 2  -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoTribunalCoarbitro2Demanda" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else coarbitro2DemandaDefault">
                            <span i18n>% Co-árbitro demandado</span>
                          </ng-container>
                          <ng-template #coarbitro2DemandaDefault>
                            <span i18n>% Co-árbitro demandado</span>
                          </ng-template>
                          {{ getArbitroRolNombre('COARBITRO_2') }}
                        </label>
                      </div>
                      <div class="col-md-2">

                        <input type="text" class="form-control text-end"
                          id="inputPorcentajePagoTribunalCoarbitro2Demanda"
                          [(ngModel)]="model.porcentaje_pago_tribunal_coarbitro_2_demanda"
                          name="porcentaje_pago_tribunal_coarbitro_2_demanda" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_demanda']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Segunda columna (6 columnas de ancho) -->
                  <div class="col-md-6">
                    <h5 class="section-title" i18n>RECONVENCIÓN</h5> <!-- Título de la segunda columna -->

                    <!-- Cuantía Reconvención -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputCuantiaReconvencion" class="form-label" i18n>Cuantía</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputCuantiaReconvencion"
                          [(ngModel)]="model.cuantia_reconvencion" name="cuantia_reconvencion" maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions" (focus)="onFocus('cuantia_reconvencion')"
                          (blur)="onBlur('cuantia_reconvencion')"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['cuantia_reconvencion']?.invalid) || (f.form.controls['cuantia_reconvencion']?.dirty || f.form.controls['cuantia_reconvencion']?.touched) && f.form.controls['cuantia_reconvencion']?.invalid }">
                      </div>
                    </div>

                    <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                    <!-- % Pago demandantes reconvencion -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoDemandantesReconvencion" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else reconvencionDemandantesDefault">
                            <span i18n>Porcentaje de pago de los demandantes (%)</span>
                          </ng-container>
                          <ng-template #reconvencionDemandantesDefault>
                            <span i18n>Porcentaje de pago de los demandantes (%)</span>
                          </ng-template>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end" id="inputPorcentajePagoDemandantesReconvencion"
                          [(ngModel)]="model.porcentaje_pago_demandantes_reconvencion"
                          name="porcentaje_pago_demandantes_reconvencion" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_demandantes_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_demandantes_reconvencion']?.dirty || f.form.controls['porcentaje_pago_demandantes_reconvencion']?.touched) && f.form.controls['porcentaje_pago_demandantes_reconvencion']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_demandantes_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_demandantes_reconvencion']?.dirty || f.form.controls['porcentaje_pago_demandantes_reconvencion']?.touched) && f.form.controls['porcentaje_pago_demandantes_reconvencion']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- % Pago demandados reconvencion -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoDemandadosReconvencion" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else reconvencionDemandadosDefault">
                            <span i18n>Porcentaje de pago de los demandados (%)</span>
                          </ng-container>
                          <ng-template #reconvencionDemandadosDefault>
                            <span i18n>Porcentaje de pago de los demandados (%)</span>
                          </ng-template>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end" id="inputPorcentajePagoDemandadosReconvencion"
                          [(ngModel)]="model.porcentaje_pago_demandados_reconvencion"
                          name="porcentaje_pago_demandados_reconvencion" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_demandados_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_demandados_reconvencion']?.dirty || f.form.controls['porcentaje_pago_demandados_reconvencion']?.touched) && f.form.controls['porcentaje_pago_demandados_reconvencion']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_demandados_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_demandados_reconvencion']?.dirty || f.form.controls['porcentaje_pago_demandados_reconvencion']?.touched) && f.form.controls['porcentaje_pago_demandados_reconvencion']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                    <!-- Porcentaje Derecho Administración Reconvención (Nuevo Campo) -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputPorcentajeDerechoAdmReconvencion" class="form-label" i18n>Derechos de
                          Administración (%)</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputPorcentajeDerechoAdmReconvencion"
                          [(ngModel)]="model.porcentaje_derecho_administracion_reconvencion"
                          name="porcentaje_derecho_administracion_reconvencion" maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_derecho_administracion_reconvencion']?.invalid) || (f.form.controls['porcentaje_derecho_administracion_reconvencion']?.dirty || f.form.controls['porcentaje_derecho_administracion_reconvencion']?.touched) && f.form.controls['porcentaje_derecho_administracion_reconvencion']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_derecho_administracion_reconvencion']?.invalid) || (f.form.controls['porcentaje_derecho_administracion_reconvencion']?.dirty || f.form.controls['porcentaje_derecho_administracion_reconvencion']?.touched) && f.form.controls['porcentaje_derecho_administracion_reconvencion']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- Porcentaje Honorarios Árbitro Reconvención (Nuevo Campo) -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputPorcentajeHonorarioReconvencion" class="form-label" i18n>Honorarios Árbitro
                          (%)</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputPorcentajeHonorarioReconvencion"
                          [(ngModel)]="model.porcentaje_honorario_arbitro_reconvencion"
                          name="porcentaje_honorario_arbitro_reconvencion" maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.invalid) || (f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.dirty || f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.touched) && f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.invalid) || (f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.dirty || f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.touched) && f.form.controls['porcentaje_honorario_arbitro_reconvencion']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                    <!-- Imputación conjunta derechos de admisión reconvención -->
                    <div class="row mb-1 align-items-center">
                      <div class="col-md-12 d-flex justify-content-between align-items-center">
                        <label for="reconvencion_imputacion_conjunta_derechos_admision" class="form-label mb-0"
                          i18n>Imputación conjunta derechos de admisión</label>
                        <div class="form-check form-switch">
                          <input type="checkbox" class="form-check-input"
                            id="reconvencion_imputacion_conjunta_derechos_admision"
                            [(ngModel)]="model.reconvencion_imputacion_conjunta_derechos_admision"
                            name="reconvencion_imputacion_conjunta_derechos_admision"
                            [disabled]="isCaseClosed() || disableOptions">
                        </div>
                      </div>
                    </div>

                    <!-- Derechos de Admisión Reconvención -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputAdmisionReconvencion" class="form-label" i18n>Derechos de admisión</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputAdmisionReconvencion"
                          [(ngModel)]="model.reconvencion_provision_admision" name="reconvencion_provision_admision"
                          maxlength="40" [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('reconvencion_provision_admision')"
                          (blur)="onBlur('reconvencion_provision_admision')">
                      </div>
                    </div>

                    <!-- Gastos Árbitros Reconvención -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputGastoArbitroReconvencion" class="form-label" i18n>Gastos de los
                          árbitros</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputGastoArbitroReconvencion"
                          [(ngModel)]="model.reconvencion_provision_gasto_arbitro"
                          name="reconvencion_provision_gasto_arbitro" maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('reconvencion_provision_gasto_arbitro')"
                          (blur)="onBlur('reconvencion_provision_gasto_arbitro')">
                      </div>
                    </div>

                    <!-- Gastos Expediente Reconvención -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputGastoExpedienteReconvencion" class="form-label" i18n>Gastos del
                          expediente</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputGastoExpedienteReconvencion"
                          [(ngModel)]="model.reconvencion_provision_gasto_expediente"
                          name="reconvencion_provision_gasto_expediente" maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('reconvencion_provision_gasto_expediente')"
                          (blur)="onBlur('reconvencion_provision_gasto_expediente')">
                      </div>
                    </div>

                    <!-- Alquiler de Sala Reconvención -->
                    <div class="row mb-1" style="align-items: baseline;">
                      <div class="col-md-6 d-flex align-items-center">
                        <label for="inputAlquilerSalaReconvencion" class="form-label" i18n>Alquiler de salas</label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" class="form-control text-end" id="inputAlquilerSalaReconvencion"
                          [(ngModel)]="model.reconvencion_provision_alquiler_sala"
                          name="reconvencion_provision_alquiler_sala" maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          (focus)="onFocus('reconvencion_provision_alquiler_sala')"
                          (blur)="onBlur('reconvencion_provision_alquiler_sala')">
                      </div>
                    </div>

                    <!-- Espacio subtítulo -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-12 d-flex align-items-center"><span i18n class="reparto-honorarios">Reparto de
                          honorarios del tribunal</span></div>
                    </div>

                    <!-- % Presidente -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoTribunalPresidenteReconvencion" class="form-label" i18n>%
                          Presidente
                          {{ getArbitroRolNombre('PRESIDENTE') }}</label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end"
                          id="inputPorcentajePagoTribunalPresidenteReconvencion"
                          [(ngModel)]="model.porcentaje_pago_tribunal_presidente_reconvencion"
                          name="porcentaje_pago_tribunal_presidente_reconvencion" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.dirty || f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.touched) && f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.dirty || f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.touched) && f.form.controls['porcentaje_pago_tribunal_presidente_reconvencion']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- % Co-árbitro 1  -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoTribunalCoarbitro1Reconvencion" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else coarbitro1ReconvencionDefault">
                            <span i18n>% Co-árbitro demandante</span>
                          </ng-container>
                          <ng-template #coarbitro1ReconvencionDefault>
                            <span i18n>% Co-árbitro demandante</span>
                          </ng-template>
                          {{ getArbitroRolNombre('COARBITRO_1') }}
                        </label>
                      </div>
                      <div class="col-md-2">
                        <input type="text" class="form-control text-end"
                          id="inputPorcentajePagoTribunalCoarbitro1Reconvencion"
                          [(ngModel)]="model.porcentaje_pago_tribunal_coarbitro_1_reconvencion"
                          name="porcentaje_pago_tribunal_coarbitro_1_reconvencion" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_1_reconvencion']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                    <!-- % Co-árbitro 2  -->
                    <div class="row mb-1" style="align-items: baseline;"
                      *ngIf="caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'">
                      <div class="col-md-10 d-flex align-items-center">
                        <label for="inputPorcentajePagoTribunalCoarbitro2Reconvencion" class="form-label">
                          <ng-container *ngIf="hasReconvencion(); else coarbitro2ReconvencionDefault">
                            <span i18n>% Co-árbitro demandado</span>
                          </ng-container>
                          <ng-template #coarbitro2ReconvencionDefault>
                            <span i18n>% Co-árbitro demandado</span>
                          </ng-template>
                          {{ getArbitroRolNombre('COARBITRO_2') }}
                        </label>
                      </div>
                      <div class="col-md-2">

                        <input type="text" class="form-control text-end"
                          id="inputPorcentajePagoTribunalCoarbitro2Reconvencion"
                          [(ngModel)]="model.porcentaje_pago_tribunal_coarbitro_2_reconvencion"
                          name="porcentaje_pago_tribunal_coarbitro_2_reconvencion" required maxlength="40"
                          [disabled]="isCaseClosed() || disableOptions"
                          [ngClass]="{ 'is-invalid': (f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.invalid }">
                        <div
                          *ngIf="(f.submitted && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.invalid) || (f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.dirty || f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.touched) && f.form.controls['porcentaje_pago_tribunal_coarbitro_2_reconvencion']?.invalid">
                          <p class="validator-message" i18n>Decimal entre 0 y 100</p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>



                <!-- Submit Button -->
                <div class="text-end mt-2">
                  <button type="submit" class="btn btn-primary waves-effect waves-light"
                    [disabled]="f.invalid || isCaseClosed() || disableOptions"
                    [hidden]="isCaseClosed() || disableOptions" i18n>Guardar</button>
                </div>
              </form>

              <div id="status" *ngIf="!loaded">
                <div class="spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>

              <div class="row"><br></div>

              <div *ngIf="filteredFinancieroDescripcion.length > 0" class="alert alert-danger">
                <strong>Error al cargar los datos financieros:</strong>
                <ul>
                  <li *ngFor="let err of filteredFinancieroDescripcion">{{ err }}</li>
                </ul>
              </div>

              <!-- DEMANDA y RECONVENCIÓN
              <div class="row" *ngIf="loaded">
                <div class="col-md-6" *ngIf="model.financiero.demanda">
                  <h5 class="section-title" i18n>Provisión de fondos (Demanda)</h5>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-8">Derechos de administración de la Corte</div>
                    <div class="col-md-4 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.derechosAdministracionCentroNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Honorarios de los árbitros</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.honorariosArbitrosNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" *ngIf="caso?.tipo_tribunal === 'TRIBUNAL_ARBITRAL'">
                    <div class="col-md-1"></div>
                    <div class="col-md-6">Presidente</div>
                    <div class="col-md-5 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.honorarios_presidente)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" *ngIf="caso?.tipo_tribunal === 'TRIBUNAL_ARBITRAL'">
                    <div class="col-md-1"></div>
                    <div class="col-md-6">
                      <ng-container *ngIf="hasReconvencion(); else coarbitroDemandanteResumenDemandaDefault">
                        <span i18n>Co-árbitro demandante reconvenido</span>
                      </ng-container>
                      <ng-template #coarbitroDemandanteResumenDemandaDefault>
                        <span i18n>Co-árbitro demandante</span>
                      </ng-template>
                    </div>
                    <div class="col-md-5 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.honorarios_coarbitro_1)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" *ngIf="caso?.tipo_tribunal === 'TRIBUNAL_ARBITRAL'">
                    <div class="col-md-1"></div>
                    <div class="col-md-6">
                      <ng-container *ngIf="hasReconvencion(); else coarbitroDemandadoResumenDemandaDefault">
                        <span i18n>Co-árbitro demandado reconviniente</span>
                      </ng-container>
                      <ng-template #coarbitroDemandadoResumenDemandaDefault>
                        <span i18n>Co-árbitro demandado</span>
                      </ng-template>
                    </div>
                    <div class="col-md-5 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.honorarios_coarbitro_2)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Gastos de los árbitros</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.gastosArbitrosTotal)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Gastos del expediente</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.gastosArbitrajeNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Alquiler de salas</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.alquilerSalasNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">SUBTOTAL</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{ getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.subtotal)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">IVA ({{
                      model.financiero.demanda.provisionFondosSimplificado.porcentajeMostarIva }}%)</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.importeIvaCalculado)
                        }}</strong>
                    </div>
                  </div>

                  <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-8"><strong>Total provisión de fondos (IVA incluido)</strong></div>
                    <div class="col-md-4 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.importeTotalProvision)
                        }}</strong>
                    </div>
                  </div>

                  <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Provisión de cada parte</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.demanda.provisionFondosSimplificado.provisionCadaParte)
                        }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="model.financiero.reconvencion">
                  <h5 class="section-title" i18n>Provisión de fondos (Reconvención)</h5>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-8">Derechos de administración de la Corte</div>
                    <div class="col-md-4 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.derechosAdministracionCentroNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Honorarios de los árbitros</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.honorariosArbitrosNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" *ngIf="caso?.tipo_tribunal === 'TRIBUNAL_ARBITRAL'">
                    <div class="col-md-1"></div>
                    <div class="col-md-6">Presidente</div>
                    <div class="col-md-5 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.honorarios_presidente)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" *ngIf="caso?.tipo_tribunal === 'TRIBUNAL_ARBITRAL'">
                    <div class="col-md-1"></div>
                    <div class="col-md-6">
                      <ng-container *ngIf="hasReconvencion(); else coarbitroDemandanteResumenReconvencionDefault">
                        <span i18n>Co-árbitro demandante reconvenido</span>
                      </ng-container>
                      <ng-template #coarbitroDemandanteResumenReconvencionDefault>
                        <span i18n>Co-árbitro demandante</span>
                      </ng-template>
                    </div>
                    <div class="col-md-5 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.honorarios_coarbitro_1)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" *ngIf="caso?.tipo_tribunal === 'TRIBUNAL_ARBITRAL'">
                    <div class="col-md-1"></div>
                    <div class="col-md-6">
                      <ng-container *ngIf="hasReconvencion(); else coarbitroDemandadoResumenReconvencionDefault">
                        <span i18n>Co-árbitro demandado reconviniente</span>
                      </ng-container>
                      <ng-template #coarbitroDemandadoResumenReconvencionDefault>
                        <span i18n>Co-árbitro demandado</span>
                      </ng-template>
                    </div>
                    <div class="col-md-5 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.honorarios_coarbitro_2)
                        }}</strong>
                    </div>
                  </div>                

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Gastos de los árbitros</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.gastosArbitrosTotal)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Gastos del expediente</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.gastosArbitrajeNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Alquiler de salas</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.alquilerSalasNeto)
                        }}</strong>
                    </div>
                  </div>

                  <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">SUBTOTAL</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{ getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.subtotal)
                        }}</strong>
                    </div>
                  </div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">IVA ({{
                      model.financiero.reconvencion.provisionFondosSimplificado.porcentajeMostarIva }}%)</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.importeIvaCalculado)
                        }}</strong>
                    </div>
                  </div>

                  <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-8"><strong>Total provisión de fondos (IVA incluido)</strong></div>
                    <div class="col-md-4 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.importeTotalProvision)
                        }}</strong>
                    </div>
                  </div>

                  <div style="border-top: 1px solid #f0f0f0; margin: 0.5rem 0;"></div>

                  <div class="row mb-1" style="align-items: baseline;">
                    <div class="col-md-6">Provisión de cada parte</div>
                    <div class="col-md-6 text-end text-resumen-custom">
                      <strong>{{
                        getFormattedValue(model.financiero.reconvencion.provisionFondosSimplificado.provisionCadaParte)
                        }}</strong>
                    </div>
                  </div>
                </div>
              </div>
              -->



            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 2" i18n>Registro de pagos</a>
            <ng-template ngbNavContent>
              <app-registro-pagos></app-registro-pagos>
            </ng-template>
          </li>
          <li [ngbNavItem]="3">
            <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 3" i18n>Tabla financiera</a>
            <ng-template ngbNavContent>
              <div class="table-responsive">
                <app-tabla-financiera [caso]="caso"></app-tabla-financiera>
              </div>
            </ng-template>
          </li>
        </ul>

        <!-- Contenedor para el contenido de las pestañas -->
        <div class="tab-content">
          <div [ngbNavOutlet]="innerNav"></div>
        </div>

      </div> <!-- end card-body -->
    </div> <!-- end card-->
  </div> <!-- end col -->
</div> <!-- end row -->
